import { useEffect, useRef } from 'react'

/**
 * Moves keyboard and screen-reader focus to an element when a screen or step
 * appears. Without it, the button that triggered the change unmounts and focus
 * falls back to the page body (WCAG 2.4.3). Target elements that are not
 * natively focusable need `tabIndex={-1}`.
 *
 * `enabled` is read once, on mount: pass false where the screen is the first
 * thing on the page, so nothing is focused (and outlined) before the user acts.
 */
export function useFocusOnMount<T extends HTMLElement>(enabled = true) {
  const ref = useRef<T>(null)
  const focusOnMount = useRef(enabled)
  useEffect(() => {
    if (focusOnMount.current) ref.current?.focus()
  }, [])
  return ref
}
